import {
  CandidateBatchStatus,
  SearchableCandidateBatchFilterInput
} from 'generated-graphql/types';
import { buildAnalysisSearchClauses } from 'utils/buildAnalysisSearchClauses';

type GetAnalysesFilterParams = {
  organizationId: string;
  userId?: string;
  isAllCampaigns: boolean;
  statusFilter?: CandidateBatchStatus;
  searchText: string;
};

export const getAnalysesFilter = ({
  organizationId,
  userId,
  isAllCampaigns,
  statusFilter,
  searchText
}: GetAnalysesFilterParams): SearchableCandidateBatchFilterInput => {
  const filter: SearchableCandidateBatchFilterInput = {
    organizationId: { eq: organizationId }
  };

  const and: SearchableCandidateBatchFilterInput[] = [];

  if (statusFilter) {
    if (statusFilter === CandidateBatchStatus.Archived) {
      // PAUSED and ARCHIVED are treated the same in the UI
      and.push({
        or: [
          { status: { eq: CandidateBatchStatus.Archived } },
          { status: { eq: CandidateBatchStatus.Paused } }
        ]
      });
    } else if (statusFilter === CandidateBatchStatus.Live) {
      and.push({
        or: [
          { status: { eq: CandidateBatchStatus.Live } },
          { status: { eq: CandidateBatchStatus.FinishedRankingCandidates } }
        ]
      });
    } else {
      filter.status = { eq: statusFilter };
    }
  } else {
    // Hide Archived and Paused by default
    and.push({ status: { ne: CandidateBatchStatus.Archived } });
    and.push({ status: { ne: CandidateBatchStatus.Paused } });
  }

  if (searchText.length > 0) {
    and.push({ or: buildAnalysisSearchClauses(searchText) });
  }

  if (and.length > 0) {
    filter.and = and;
  }

  if (!isAllCampaigns && userId) {
    filter.userId = { eq: userId };
  }

  return filter;
};
